import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.1448 14.3134L5.38673 4.5553C5.07431 4.24288 4.56778 4.24288 4.25536 4.5553C3.94294 4.86772 3.94294 5.37426 4.25536 5.68667L14.0134 15.4447C14.3259 15.7572 14.8324 15.7572 15.1448 15.4447C15.4572 15.1323 15.4572 14.6258 15.1448 14.3134Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "0.4"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.0131 4.55564L4.25501 14.3137C3.94259 14.6261 3.94259 15.1327 4.25501 15.4451C4.56743 15.7575 5.07396 15.7575 5.38638 15.4451L15.1445 5.68701C15.4569 5.37459 15.4569 4.86805 15.1445 4.55564C14.832 4.24322 14.3255 4.24322 14.0131 4.55564Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "0.4"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CloseIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "close",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})